import React, { useState, useMemo } from "react";
import { CreateInflow } from "../../pages";
import { WalletController } from "../../controllers";
import { walletStore } from "../../stores";

const CreateInflowContainer = () => {
  const [loading, setLoading] = useState(false);
  const [createInflowModal, setCreateInflowModal] = useState(false);
  const [reviewInflowModal, setReviewInflowModal] = useState(false);
  const [viewInflowModal, setViewInflowModal] = useState(false);

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const outflowTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = WalletController.useGetOutflow(
    outflowTableQuery,
    filterQuery,
    searchQuery,
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToCreateInflow = () => {
    setCreateInflowModal(true);
  };

  const goToReviewInflow = (item) => {
    walletStore.setInflowData(item);
    setReviewInflowModal(true);
  };

  const goToViewInflowDetails = (item) => {
    walletStore.setInflowData(item);
    setViewInflowModal(true);
  };

  const closeModal = () => {
    setCreateInflowModal(false);
    setReviewInflowModal(false);
    setViewInflowModal(false);
  };

  return (
    <CreateInflow
      goToCreateInflow={goToCreateInflow}
      loading={loading}
      closeModal={closeModal}
      createInflowModal={createInflowModal}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      onLimitChange={onLimitChange}
      limit={limit}
      setSearchQuery={setSearchQuery}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      goToReviewInflow={goToReviewInflow}
      reviewInflowModal={reviewInflowModal}
      goToViewInflowDetails={goToViewInflowDetails}
      viewInflowModal={viewInflowModal}
    />
  );
};
export default CreateInflowContainer;
